import { render, staticRenderFns } from "./question-and-answer-card.vue?vue&type=template&id=c85fb45a&scoped=true&"
import script from "./question-and-answer-card.vue?vue&type=script&lang=js&"
export * from "./question-and-answer-card.vue?vue&type=script&lang=js&"
import style0 from "./question-and-answer-card.vue?vue&type=style&index=0&id=c85fb45a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85fb45a",
  null
  
)

export default component.exports